/* eslint-disable react-hooks/exhaustive-deps */
import { Block } from '@xprog/prensa'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'
import CallToActionButton from 'components/Buttons/CallToActionButton.index'
import ClearFiltersButton from 'components/Buttons/CallToActionOutlinedButton.index'
import DatePicker from 'components/DatePicker/DatePicker.index'
import Input from 'components/Input/InputEdital.index'
import Select from 'components/Select/Select.index'
import each from 'lodash/each'
import get from 'lodash/get'
import { FilterContext } from 'providers/Filter'
import { FilterDataContext } from 'providers/FilterData'
import React, { useContext, useState } from 'react'

interface EditaisFiltersProps {
  categorization?: any;
  children?: any;
  className?: string;
  customLink?: any;
  customLinkProps?: any;
  customProps?: { className?: string; };
  slotTemplateCode?: any;
}

const containerProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  mb: '$4',
  mr: '$0',
  width: '100%'
}
const selectProps = {
  container: {
    mb: '$4'
  }
}

const prepareTagFilters = (categorization, { selectedCompany, selectedSector }) => {
  
  const companies: string[] = get(categorization, 'company', [])
  const docTypes: string[] = get(categorization, 'type', [])
  const sectors: string[] = get(categorization, 'sector', [])

  companies.sort(function (a, b) {
    return a.localeCompare(b)
  })
  sectors.sort(function (a, b) {
    return a.localeCompare(b)
  })
  docTypes.sort(function (a, b) {
    return a.localeCompare(b)
  })

  const companiesData: any[] = [{ id: -1, title: 'Nenhum', selected: true }]
  each(companies, (item, key) =>
    companiesData.push({
      id: key,
      title: item,
      selected: item == selectedCompany?.title
    })
  )
  const sectorsData: any[] = [{ id: -1, title: 'Nenhum', selected: true }]
  each(sectors, (item, key) =>
    sectorsData.push({
      id: key,
      title: item,
      selected: item == selectedSector?.title
    })
  )
  const docTypesData: any[] = [{ id: -1, title: 'Nenhum', selected: true }]
  each(docTypes, (item, key) =>
    docTypesData.push({
      id: key,
      title: item,
      selected: item == selectedSector?.title
    })
  )
  return { companies, companiesData, docTypes, docTypesData, sectors, sectorsData }
}

const EditaisFilters: React.FC<EditaisFiltersProps> = (props) => {
  const filterContext = useContext(FilterContext)
  const filterDataContext = useContext(FilterDataContext)
  const tagFilters = prepareTagFilters(props.categorization, { selectedCompany: {}, selectedSector: {} })
  const [date, setDate] = useState<Date | null>(null)
  const [companiesList, setCompaniesList] = useState(tagFilters.companiesData)
  const [docTypesList, setdocTypesList] = useState(tagFilters.docTypesData)
  const [sectorsList, setSectorsList] = useState(tagFilters.sectorsData)
  const [cnpjFilter, setCNPJFilter] = useState('')
  const clientSlug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG

  const slotPolicyId = props?.slotTemplateCode
  const slotFilters = filterContext.filters[slotPolicyId]
  const isFiltersDisabled = filterDataContext.loading

  const handleCompanyFilter = (value) => {
    const newState = companiesList.map((i: any) => ({ ...i, selected: i.title === value ? true : false }))
    setCompaniesList(newState)
  }

  const handleSectorFilter = (value) => {
    const newState = sectorsList.map((i: any) => ({ ...i, selected: i.title === value ? true : false }))
    setSectorsList(newState)
  }

  const handleDocTypeFilter = (value) => {
    const newState = docTypesList.map((i: any) => ({ ...i, selected: i.title === value ? true : false }))
    setdocTypesList(newState)
  }

  const handleNumberFilter = (value) => {
    setCNPJFilter(fromStringToCNPJ(value))
  }

  const handleDate = (e) => {
    setDate(e)
  }

  const fromStringToCNPJ = (value) => {
    let x: string = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/)
    x = !x[2] ? x[1] : x[1] + '.' + x[2] + (x[3] ? '.' + x[3] : '') + (x[4] ? '/' + x[4] : '') + (x[5] ? '-' + x[5] : '')
    return x
  }

  const fromCNPJToString = (value) => {
    return value.replace(/[^\d]/g, '')
  }

  const handleFilter = () => {
    const companiesSelected = companiesList.find((i) => i.selected)
    const docTypesSelected = docTypesList.find((i) => i.selected)
    const sectorsSelected = sectorsList.find((i) => i.selected)
    const categorizationParams: Array<string> = []
    const dateParams = {}
    
    if (companiesSelected.id !== -1) {
      categorizationParams.push(`tag_ojc.dimension.Editais.Empresa:${companiesSelected.title}`)
    }
    if (docTypesSelected.id !== -1) {
      categorizationParams.push(`tag_ojc.dimension.Editais.Tipo:${docTypesSelected.title}`)
    }
    if (sectorsSelected.id !== -1) {
      categorizationParams.push(`tag_ojc.dimension.Editais.Setor:${sectorsSelected.title}`)
    }
    if (cnpjFilter !== '') {
      categorizationParams.push(`tag_ojc.dimension.Editais.CNPJ:${fromCNPJToString(cnpjFilter)}`)
    }
    if (date !== null) {
      dateParams['dateStart'] = new Date(new Date(date).setHours(0, 0, 0)).toISOString()
      dateParams['dateEnd'] = new Date(new Date(date).setHours(23, 59, 59)).toISOString()
    }
    filterDataContext.loadSearchEngineData({
      ...dateParams,
      policyId: slotPolicyId,
      categorization: categorizationParams,
      pageRows: slotFilters.pageRows,
      pageStart: 0
    }, { isSearchEngine: true })
  }

  const handleClearState = () => {
    const newCompaniesState = companiesList.map((i: any) => ({ ...i, selected: i.id === -1 ? true : false }))
    const newSectorsState = sectorsList.map((i: any) => ({ ...i, selected: i.id === -1 ? true : false }))
    const newDocTypeState = docTypesList.map((i: any) => ({ ...i, selected: i.id === -1 ? true : false }))
    const newCNPJState = ''
    const newDateState = null

    setCompaniesList(newCompaniesState)
    setSectorsList(newSectorsState)
    setdocTypesList(newDocTypeState)
    setCNPJFilter(newCNPJState)
    setDate(newDateState)
    filterContext.updateFilter(slotPolicyId, {
      pageStart: 0
    })
    filterDataContext.loadSearchEngineData({
      policyId: slotPolicyId,
      pageRows: slotFilters.pageRows,
      pageStart: 0
    }, { isSearchEngine: true })
  }

  const selectedCompanyOption = companiesList.find((i) => i.selected)
  const selectedSectorsOption = sectorsList.find((i) => i.selected)
  const selectedDocTypeOption = docTypesList.find((i) => i.selected)

  return (
    <Block css={{ ...containerProps }}>
      <Block css={{ mb: '$4', width: '100%' }}>
        <Select
          id='Empresa'
          label='Empresa'
          onChange={({ target }) => handleCompanyFilter(target?.value)}
          options={companiesList}
          value={selectedCompanyOption.title}
          disabled={isFiltersDisabled}
          css={selectProps}
        />
        <Select
          id='Setor'
          label='Setor'
          onChange={({ target }) => handleSectorFilter(target?.value)}
          options={sectorsList}
          value={selectedSectorsOption.title}
          disabled={isFiltersDisabled}
          css={selectProps}
        />
        <Select
          id='Tipo'
          label='Tipo'
          onChange={({ target }) => handleDocTypeFilter(target?.value)}
          options={docTypesList}
          value={selectedDocTypeOption.title}
          disabled={isFiltersDisabled}
          css={selectProps}
        />
        <Input
          id='CNPJ'
          onChange={({ target }) => handleNumberFilter(target?.value)}
          placeholder='00.000.000/0000-00'
          type='string'
          value={cnpjFilter}
          disabled={isFiltersDisabled}
        />
        <DatePicker
          selectedDate={date || new Date(Date.now())}
          onChange={handleDate}
        />
      </Block>
      <CallToActionButton
        disabled={isFiltersDisabled}
        onClick={handleFilter}
        css={{
          button: {
            mb: '$4',
            width: '100%',
            backgroundColor: clientSlug == 'daqui' ? '$secondaryMain' : '$primary800'
          },
        }}
      >
        Filtrar
      </CallToActionButton>
      <ClearFiltersButton
        disabled={isFiltersDisabled}
        onClick={handleClearState}
        css={{
          button: {
            height: '42px',
            width: '100%',
            '&:disabled': { borderColor: 'rgb(167, 167, 167)', backgroundColor: '$basicWhite' }
          },
          label: {
            color: isFiltersDisabled ? 'rgb(167, 167, 167)' : clientSlug == 'daqui' ? '$secondaryMain' : '$primaryMain'
          }
        }}
      >
        Limpar Filtros
      </ClearFiltersButton>
    </Block>
  )
}

export default EditaisFilters
